<script module>
	let registerDialog

	export function show_register() {
		registerDialog?.showModal()
	}
</script>


<!-------------------------------- HTML ---------------------------------->

<dialog bind:this={registerDialog} id="register-dialog" data-help="register" onclose={reset}>
	<span class="close" onclick={() => registerDialog.close()}>&times;</span>
	<h3 class="title">Account anlegen</h3>
	<p>Der kostenfreie Account bei Pentelion erlaubt Dir eigene Helden anzulegen und an Abenteuern teilzunehmen, die Dein Spielleiter erstellt hat.
		In der Testphase benötigst Du noch eine Einladung zu einer Gruppe, um Dich anmelden zu können.
		Später kannst Du auch eigene Abenteuer erstellen.</p>
	<hr>
	<br>
	{#if message}
		<p class="message" class:error={message.slice(-1) === '!'}>{message}</p>
	{/if}
	<div class="form-group">
		<div class="field">
			<label class="field-label" for='invite'>Einladungscode</label>
			<input id='invite' bind:value={invite} class="field-control" type="text" required autocomplete="off">
		</div>
		<div class="field">
			<label class="field-label" for="reg-email" data-help="regemail">E-Mail</label>
			<input id="reg-email" data-help="regemail" bind:value={email} class="field-control" type="email" required autocomplete="email">
		</div>
		<div class="field">
			<label class="field-label" for="reg-name" data-help="email">Benutzername</label>
			<input id="reg-name" data-help="email" bind:value={name} class="field-control" type="text" required autocomplete="off">
		</div>
		<div class="field">
			<label class="field-label" for="reg-password" data-help="password">Passwort</label>
			<input id="reg-password" data-help="password" bind:value={password} class="field-control" type="password" required autocomplete="new-password">
		</div>
	</div>
	<div class="actions">
		{#if !user.ID}
			<button class="btn-primary btn-primary-circle icon-user-plus" onclick={register}>Registrieren</button>
			<button class="button-secondary" onclick={() => registerDialog.close()}>Abbrechen</button>
		{:else}
			<button class="btn-primary btn-primary-circle icon-check" onclick={() => registerDialog.close()}>OK</button>
		{/if}
	</div>
</dialog>


<!------------------------------ SCRIPT ---------------------------------->

<script>
		import {user, send_data} from "../client.svelte.js"

		let invite = $state("")
		let email = $state("")
		let name = $state("")
		let password = $state("")
		let message = $state("")

		function reset() {
			invite = ""
			email = ""
			name = ""
			password = ""
			message = ""
		}

		async function register() {
				if (!(email && name && password)) {
						message = "Bitte fülle alle Felder aus!"
						return
				}
				try {
						await send_data("/register", {invite: invite, email, name, password})
						message = `Registrierung erfolgreich! Du bist jetzt als „${name}" angemeldet.`
						user.login(name, password)
				} catch (err) {
						console.log(err)
						try {
								const errJSON = JSON.parse(err.message)
								message = errJSON.description + '!'
						} catch (e) {
								message = err.message ?? "Registrierung fehlgeschlagen!"
						}
				}
		}

</script>


<!------------------------------ STYLE ---------------------------------->

<style lang="sass">
	@use "../colors" as colors

	#register-dialog
		background-color: #252626
		color: colors.$white
		border: 1px solid #555
		border-radius: 8px
		padding: 24px 32px 20px 32px
		width: min(60%, 480px)

	#register-dialog::backdrop
		background: rgba(0, 0, 0, 0.6)

	.title
		margin: 0 0 16px 0
		font-size: 18px
		font-weight: bold

	.close
		position: absolute
		top: 10px
		right: 14px
		color: #aaa
		font-size: 22px
		font-weight: bold
		cursor: pointer

	.close:hover
		color: colors.$white

	.form-group
		display: flex
		flex-flow: column nowrap
		gap: 8px

	.field
		display: flex
		flex-flow: column nowrap

	.field-label
		color: colors.$white
		margin-bottom: 4px
		font-size: 13px

	.field-control
		background-color: #9C9797
		border: none
		border-radius: 5px
		color: black
		padding: 4px 6px

	.message
		margin: 0 0 12px 0
		font-size: 13px
		color: #6fcf97

	.message.error
		color: #eb5757

	.actions
		display: flex
		flex-flow: row nowrap
		align-items: center
		gap: 16px
		margin-top: 20px

	.button-secondary
		background: none
		border: 1px solid #555
		color: colors.$white
		border-radius: 20px
		padding: 6px 14px
		cursor: pointer

	.button-secondary:hover
		border-color: colors.$white

	.icon-user-plus::before
		content: "\e541"
</style>